import { apiV1Endpoint } from "../../../../../api/v1";
import axios from "../../../../../utils/axiosInceptor";

const RECEIPT_BASE = `${apiV1Endpoint}/receipt`;

export type ReceiptListParams = Record<string, unknown>;

export const getReceiptList = async (params: ReceiptListParams, paymentReceiptId: string | null = null) => {
  const url = paymentReceiptId ? `${RECEIPT_BASE}/details/${paymentReceiptId}?details=${true}` : `${RECEIPT_BASE}/list`;

  const response = await axios.get(url, paymentReceiptId ? {} : { params });
  return response.data;
};

export type ReceiptExportPayload = {
  query: Record<string, unknown>;
  columns: string[] | undefined;
};

export const postReceiptExport = async (payload: ReceiptExportPayload) => {
  const url = `${RECEIPT_BASE}/export`;
  const response = await axios.post(url, payload);
  return response.data;
};

export type ReceiptChequeBouncePayload = {
  paymentReceiptId: string;
  penaltyPaymentMode?: string;
  actualAmount?: number;
  penaltyFee?: number;
  vat?: number;
  reason?: string;
  paymentRefReplaced?: string;
  paymentNote?: string;
  [key: string]: unknown;
};

export const postReceiptChequeBounce = async (payload: ReceiptChequeBouncePayload) => {
  const url = `${RECEIPT_BASE}/bounce`;
  const response = await axios.post(url, payload);
  return response.data;
};

export const replaceReceiptChequeBounce = async (payload: ReceiptChequeBouncePayload) => {
  const url = `${RECEIPT_BASE}/replace-cheque`;
  const response = await axios.post(url, payload);
  return response.data;
};

export type ReceiptChequeClearPayload = {
  paymentReceiptId?: string | string[];
  isCleared?: boolean;
  clearedDate?: string;
  [key: string]: unknown;
};

export const postReceiptChequeClear = async (payload: ReceiptChequeClearPayload) => {
  const url = `${RECEIPT_BASE}/clear`;
  const response = await axios.post(url, payload);
  return response.data;
};

export type ReceiptDeferPayload = {
  paymentReceiptId?: string;
  pdcId?: string;
  deferredDate?: string;
  deferred?: {
    isApplyDefferalFee?: string;
    amount?: number;
    vat?: number;
    total?: number;
    reason?: string;
    approval?: string;
  };
  [key: string]: unknown;
};

export const postReceiptDefer = async (payload: ReceiptDeferPayload) => {
  const url = `${RECEIPT_BASE}/defer`;
  const response = await axios.post(url, payload);
  return response.data;
};

export type ReceiptRecallRequestPayload = {
  paymentReceiptId?: string;
  chequeNumber?: string;
  amountToPay?: number;
  bankName?: string;
  paidDate?: string;
  recallType?: "recallOnly" | "replaceWithNewReceipt";
  recallReason?: string;
  subPdcId?: string;
  subChequeNumber?: string;
  modeOfPayment?: string;
  documentNo?: string;
  depositDate?: string;
  depositTo?: string;
  depositToBank?: string;
  waiveOff?: boolean;
  [key: string]: unknown;
};

export const postReceiptRecallRequest = async (payload: ReceiptRecallRequestPayload) => {
  const url = `${RECEIPT_BASE}/recallReceiptRequest`;
  const response = await axios.post(url, payload);
  return response.data;
};

export type UpdateReceiptRecallRequestPayload = {
  paymentReceiptId?: string;
  status: "approved" | "rejected";
};

export const postUpdateRecallReceiptRequest = async (payload: UpdateReceiptRecallRequestPayload) => {
  const url = `${RECEIPT_BASE}/updateRecallReceiptRequest`;
  const response = await axios.post(url, payload);
  return response.data;
};
